import { Guid } from '../guid';
import { Fact } from './fact.model';

export class Issue {
	id: string = Guid.Empty;
	caseId: string = Guid.Empty;
	title: string = '';
	description: string = '';
	facts: Fact[];
}
